<template>
  <div>
    <h3 class="dashboard-header">Today's Weather</h3>
    <hr>
    <!-- <h2>{{ weather.main.temp - 273.15 | noDecimals }}°C <span style="font-size: 20px;">{{ weather.weather[0].description }}</span><img :src="iconURL" alt=""></h2> -->
    <h2 v-if="weather.main">{{ weather.main.temp - 273.15 | noDecimals }}°C  <span style="font-size: 20px;"> {{ weather.weather[0].description }}</span></h2>
    <!-- <h2>{{ weather.main.temp - 273.15 | noDecimals }}°C </h2> -->
    <!-- <img :src="iconURL" alt=""><span style="font-size: 20px;">{{ weather.weather[0].description }}</span> -->
    <!-- <p>{{ weather.weather[0].description }}</p> -->
    <!-- {{ weather }} -->
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    props: ['user'],
    data () {
      return {
        weather: {},
        iconURL: 'http://openweathermap.org/img/wn/10d@2x.png', // https://openweathermap.org/weather-conditions
      }
    },
    created() {
      this.getWeather()
    },
    methods: {
      getWeather() {
        // https://openweathermap.org/current
        // http://api.openweathermap.org/data/2.5/weather?q=London,uk&APPID=3296d5325540b42846523a666b35ab90
        axios.get('https://cors-anywhere.herokuapp.com/https://api.openweathermap.org/data/2.5/weather?q=Toronto,ca&APPID=3296d5325540b42846523a666b35ab90')
          .then(res => {
            console.log(res)
            this.weather = res.data

            if (this.user.team == 'JKR') {
              console.log('Getting Cincinnati Weather')
              axios.get('https://cors-anywhere.herokuapp.com/https://api.openweathermap.org/data/2.5/weather?q=Cincinnati&APPID=3296d5325540b42846523a666b35ab90')
              .then(res => {
                console.log(res)
                this.weather = res.data
              })
              .catch(error => console.log(error))
            }
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/Weather.vue